import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ListIcon } from "../shared/icons";

const Navbar: React.FC = () => {
  const [isMainMenuClick, setIsMainMenuClick] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth > 768) {
      setIsMainMenuClick(false);
    }
  }, [windowWidth]);

  const labels = useMemo(
    () => [
      // { id: 1, title: "Home", path: "/" },
      { id: 2, title: "Travel", path: "/travel" },
      { id: 3, title: "Guides", path: "/guides" },
      { id: 4, title: "Food", path: "/food" },
      { id: 5, title: "Hotels", path: "/hotels" },
    ],
    [],
  );
  const location = useLocation();

  // 當路由變化時，關閉移動端菜單
  useEffect(() => {
    setIsMainMenuClick(false);
  }, [location.pathname]);

  return (
    <>
      <div className="h-[55px] items-center justify-center md:flex hidden">
        <ul className="flex items-center justify-between w-full gap-x-7 font-medium text-gray-700 cursor-pointer">
          {labels.map((label, id) => (
            <Link key={id} to={label.path}>
              <li
                key={id}
                className={`flex items-center justify-center ${
                  location.pathname === label.path
                    ? "font-extrabold text-[#c9b077]"
                    : "hover:font-extrabold hover:text-[#c9b077]"
                }`}
              >
                <span className="lg:text-xl text-lg">{label.title}</span>
              </li>
            </Link>
          ))}
        </ul>
      </div>

      <div
        className="items-center relative z-[100] cursor-pointer flex md:hidden"
        onClick={() => setIsMainMenuClick(!isMainMenuClick)}
      >
        {/* <img src="/icon/list2.png" alt="list2Icon" className="w-7 h-7 mr-0.5" /> */}
        <ListIcon />
      </div>
      {isMainMenuClick && (
        <div className="absolute sm:top-[56px] top-[60px] left-0 w-full z-[100]">
          <ul className="flex justify-between bg-white/100 sm:px-11 px-10 sm:text-lg text-base font-semibold text-gray-700 cursor-pointer">
            {labels.map((label, id) => (
              <Link key={id} to={label.path}>
                <li
                  key={id}
                  className={`flex items-center py-3 ${
                    location.pathname === label.path
                      ? "font-extrabold text-[#c9b077]"
                      : "hover:font-extrabold hover:text-[#c9b077]"
                  }`}
                >
                  <span>{label.title}</span>
                </li>
              </Link>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;
